"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Return the absolute value of a number.
 *
 * @param {number} x
 * @returns {number}
 */
function abs(x) {
    return Math.abs(x);
}
exports.abs = abs;
